export default {
    title: '個人資料'
}
